import { Search, Shield, User } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useViewModeStore } from '@/stores/view-mode';
import { AlertasBell } from '@/components/licitacoes/AlertasBell';
import { ThemeToggle } from './ThemeToggle';
import { ViewModeSwitcher } from './ViewModeSwitcher';
import { Input } from './Input';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const mode = useViewModeStore((state) => state.mode);
  const isUsersPage = location.pathname === '/usuarios';
  const isOwnerAdmin = user?.email?.toLowerCase() === 'admin@alpendre.infra';

  return (
    <header className="h-20 bg-ds-surface border-b border-ds-border flex items-center gap-3 px-6 xl:gap-6">
      {/* Search */}
      <div className="min-w-0 flex-1 max-w-xs ml-12 lg:ml-0">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ds-text-secondary" />
          <Input
            type="text"
            placeholder="Buscar..."
            className="pl-10 bg-ds-surface2 border-ds-border"
          />
        </div>
      </div>

      {/* Right actions */}
      <div className="ml-auto flex shrink-0 items-center gap-2 xl:gap-4">
        <ViewModeSwitcher />

        <div className="h-6 w-px bg-ds-border" />

        {mode === 'consultor' && isOwnerAdmin && (
          <button
            onClick={() => navigate('/usuarios')}
            className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
              isUsersPage
                ? 'bg-ds-brand-subtle/30 text-ds-brand'
                : 'text-ds-text-secondary hover:bg-ds-surface2 hover:text-ds-text-primary'
            }`}
          >
            <Shield className="h-4 w-4" />
            USUARIOS
          </button>
        )}

        <AlertasBell />

        <ThemeToggle />

        <div className="h-6 w-px bg-ds-border" />

        <button onClick={() => navigate('/perfil')} className="flex items-center gap-2 p-2 rounded-lg hover:bg-ds-surface2 transition-colors xl:gap-3">
          <div className="w-8 h-8 rounded-full bg-ds-brand-subtle/30 flex items-center justify-center">
            <User className="h-4 w-4 text-ds-brand" />
          </div>
          <span className="text-sm font-medium text-ds-text-primary hidden xl:block">
            Perfil
          </span>
        </button>
      </div>
    </header>
  );
}

export { Header };
